<template>
    <div class="container"  v-title="'帮助中心'">
        <Navigation-bar id="navigation_bar" type="dark"></Navigation-bar>
        <div class="container_content">
            <div class="title">
                <h2>帮助中心</h2>
                <YD-image class="logo" src="logo_新"></YD-image>
                <p class="subTitle">使用教程</p>
            </div>
            <div id="HelpCenter">
                <div class="HelpCenter_content">
                    <div class="list">
                        <div class="item" v-for="(item,index) in list" :key="index" @click="go2Detail(item.title)">
                            <div class="item_title">
                                <div class="num">{{index + 1}}</div>
                                <span>{{item.title}}</span>
                            </div>
                            <YD-image src="icon/icon_table_cell_arrow"></YD-image>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { get } from '@/api/htmlRequest'
export default {
    name: 'HelpCenter',
    data() {
        return {
            list: []
        }
    },
    created(){
        get(process.env.VUE_APP_PUBLIC_URL + '/html/帮助中心/web.json').then(data=>{
            this.list = data;
        })
    },
    methods:{
        go2Detail(title){
            this.$navigation.go('/Rules/HelpCenterDetail?title=' + encodeURIComponent(title));
        }
    }
};
</script>
<style lang="scss" scoped>
.title{
    height: 198px;
    padding: 24px 40px 0;
    box-sizing: border-box;
    background: #1B1C1E;
    position: relative;
    h2{
        @include line-height(84px);
        font-size: 60px;
        color: #FFFFFF;
        font-weight: 500;
    }
    .logo{
        width: 106px;
        height: 56px;
        position:absolute;
        right: 40px;
        top: 38px;
    }
    p{
        @include line-height(44px);
        font-size: 32px;
        color: #999999;
        font-weight: 400;
        margin-top: 6px;
    }
}
#HelpCenter{
    .HelpCenter_content{
        padding: 40px 0;
		padding-bottom: calc(40px + var(--safe-area-inset-bottom));
        box-sizing: border-box;
        .list{
            .item{
                width: 100%;
                min-height: 100px;
                padding-left: 30px;
                padding-right: 24px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .item_title{
                    width: calc(100% - 48px);
                    display: flex;
                    align-items: center;
                    .num{
                        width: 64px;
                        height: 64px;
                        @include bg-image('~@images/icon/icon_helpCenter_catalogue');
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        font-family: PingFangSC-Semibold;
                        font-size: 28px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 64px;
                        font-weight: 600;
                        margin-right: 12px;
                    }
                    span{
                        font-family: PingFangSC-Medium;
                        font-size: 28px;
                        color: #333333;
                        letter-spacing: 0;
                        line-height: 40px;
                        font-weight: 500;
                    }
                }
                img{
                    width: 48px;
                    height: 48px;
                }
            }
        }
    }
}
</style>